<div (click)="open('/main/gateways')"
     class="rounded-2 border-3 border-bottom background-pure-white p-3 pointer pointer-hover height-100px">
    <div class=" d-flex justify-content-between">
        <div class=" fs-main fw-bold mb-3">LoRa Gateways</div>
        <div class=" mt-auto mb-auto">
            <i class="color-primary-blue fa-solid fa-chevron-right fa-lg"></i>
        </div>
    </div>
    <div class="d-flex gap-2">
        @if (onlineStateGateways.length > 0) {
            <div>
                <app-gateway-svg [backgroundColor]="'#348D1D'"
                                [height]="'30px'"
                                [online]="true"
                                [width]="'30px'"
                                class="img-fluid img-max m-auto"></app-gateway-svg>
                <span class="p-2">{{ onlineStateGateways.length }}</span>
            </div>
        }
        @if (unknownStateGateways.length > 0) {
            <div>
                <app-gateway-svg [backgroundColor]="'#dfdfde'"
                                [height]="'30px'"
                                [online]="true"
                                [width]="'30px'"
                                class="img-fluid img-max m-auto"></app-gateway-svg>
                <span class="p-2">{{ unknownStateGateways.length }}</span>
            </div>
        }
        @if (offlineStateGateways.length > 0) {
            <div>
                <app-gateway-svg [backgroundColor]="'#FF401F'"
                                [height]="'30px'"
                                [online]="true"
                                [width]="'30px'"
                                class="img-fluid img-max m-auto"></app-gateway-svg>
                <span class="p-2">{{ offlineStateGateways.length }}</span>
            </div>
        }
    </div>
</div>
